(function () {
  if (customElements.get('wiggensbach-streamer-sticky-buy')) return;

  customElements.define(
    'wiggensbach-streamer-sticky-buy',
    class WiggensbachStreamerStickyBuy extends HTMLElement {
      constructor() {
        super();

        this.animationFrame = null;
        this.observer = null;
        this.variantUnsubscriber = null;
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleObservedChange = this.handleObservedChange.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.button = this.querySelector('[data-sticky-buy-submit]');
        this.buttonLabel = this.querySelector('[data-sticky-buy-label]');
        this.priceTarget = this.querySelector('[data-sticky-buy-price]');
        this.stockTarget = this.querySelector('[data-sticky-buy-stock]');
        this.footer = document.querySelector('.wiggensbach-footer') || document.querySelector('footer');
        this.defaultLabel = this.dataset.buttonLabel || 'Jetzt bestellen';
        this.availableLabel = this.dataset.availableLabel || '';
        this.unavailableLabel = this.dataset.unavailableLabel || '';

        if (!this.productInfo || !this.button) return;

        this.cacheSourceElements();
        this.button.addEventListener('click', this.handleButtonClick);
        window.addEventListener('scroll', this.handleViewportChange, { passive: true });
        window.addEventListener('resize', this.handleViewportChange);

        this.observeSourceElements();
        this.subscribeToVariantChanges();
        this.syncState();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleButtonClick);
        window.removeEventListener('scroll', this.handleViewportChange);
        window.removeEventListener('resize', this.handleViewportChange);
        this.observer?.disconnect();
        this.variantUnsubscriber?.();

        if (this.animationFrame) {
          window.cancelAnimationFrame(this.animationFrame);
        }
      }

      cacheSourceElements() {
        this.heroSubmit = this.productInfo.querySelector('.wig-streamer-product__submit');
        this.heroPrice = this.productInfo.querySelector('.wig-streamer-product__price');
        this.heroStock = this.productInfo.querySelector('.wig-streamer-product__stock');
      }

      observeSourceElements() {
        this.observer?.disconnect();
        this.observer = new MutationObserver(this.handleObservedChange);

        [this.heroSubmit, this.heroPrice, this.heroStock].forEach((element) => {
          if (!element) return;

          this.observer.observe(element, {
            attributes: true,
            childList: true,
            subtree: true,
          });
        });
      }

      subscribeToVariantChanges() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== this.productInfo?.dataset?.section) return;

          this.currentVariant = event.data.variant;
          this.cacheSourceElements();
          this.observeSourceElements();
          this.syncState();
        });
      }

      handleObservedChange() {
        this.syncState();
      }

      handleButtonClick(event) {
        event.preventDefault();
        this.cacheSourceElements();

        if (!this.heroSubmit || this.button.disabled) return;

        this.heroSubmit.click();
      }

      handleViewportChange() {
        if (this.animationFrame) return;

        this.animationFrame = window.requestAnimationFrame(() => {
          this.animationFrame = null;
          this.updateVisibility();
        });
      }

      updateVisibility() {
        if (!this.productInfo) return;

        const heroRect = this.productInfo.getBoundingClientRect();
        const shouldShow = heroRect.bottom <= 0;

        this.updateFooterOffset();
        this.classList.toggle('is-visible', shouldShow);
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      updateFooterOffset() {
        if (!this.footer?.isConnected) {
          this.footer = document.querySelector('.wiggensbach-footer') || document.querySelector('footer');
        }

        if (!this.footer) {
          this.style.setProperty('--wsp-sticky-footer-offset', '0px');
          return;
        }

        const footerRect = this.footer.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const footerOverlap = Math.max(0, viewportHeight - footerRect.top);

        this.style.setProperty('--wsp-sticky-footer-offset', `${Math.round(footerOverlap)}px`);
      }

      syncState() {
        this.cacheSourceElements();

        if (!this.heroSubmit || !this.button) return;

        const isUnavailable = this.heroSubmit.hasAttribute('disabled');
        const isLoading = this.heroSubmit.getAttribute('aria-disabled') === 'true' && !isUnavailable;
        const submitText = this.getSubmitText();

        this.button.disabled = isUnavailable || isLoading;
        this.button.setAttribute('aria-disabled', this.button.disabled ? 'true' : 'false');
        this.classList.toggle('is-loading', isLoading);
        this.classList.toggle('is-unavailable', isUnavailable);

        if (this.buttonLabel) {
          this.buttonLabel.textContent = isUnavailable ? submitText || this.unavailableLabel : this.defaultLabel;
        }

        this.syncPrice();
        this.syncStock(isUnavailable, submitText);
      }

      syncPrice() {
        if (!this.heroPrice || !this.priceTarget) return;

        this.priceTarget.innerHTML = this.heroPrice.innerHTML;
        this.priceTarget.classList.toggle('hidden', this.heroPrice.classList.contains('hidden'));
      }

      syncStock(isUnavailable, submitText) {
        if (!this.stockTarget) return;

        const sourceText = this.heroStock?.textContent?.trim();
        const stockText = isUnavailable
          ? submitText || this.unavailableLabel
          : this.availableLabel || sourceText || '';

        this.stockTarget.textContent = stockText;
        this.stockTarget.classList.toggle('wig-streamer-product__sticky-stock--sold-out', isUnavailable);
      }

      getSubmitText() {
        const label = this.heroSubmit?.querySelector('span');
        return label?.textContent?.trim() || '';
      }
    }
  );
})();
